import { IFilter } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import i18n from "@/i18n";

const ticketDepartmentsFilters: IFilter[] = [
  {
    key: "name",
    label: i18n.t("_.name"),
    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS,
    group: "department"
  },
  {
    key: "username",
    label: i18n.t("_.mailbox"),
    type: FilterTypes.STRING,
    operator: FilterOperators.CONTAINS,
    group: "department"
  },
  {
    key: "created_at",
    label: i18n.t("_.date_created"),
    type: FilterTypes.DATE,
    operator: FilterOperators.AFTER,
    group: "client"
  }
];

export default ticketDepartmentsFilters;
